import type {FondFieldType} from '../types';
import type {Fond} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';

/**
 * @ngdoc service
 * @name fondsDataService
 * @module use-cases.fonds
 *
 *
 * @description
 * Data service for providing the newest documents
 */
export class FondsDataService {
    public static serviceName = 'fondsDataService';

    private static readonly ROUTE = 'fonds';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getAll(): Promise<Fond[]> {
        return this.ajaxService
            .createRequest(FondsDataService.ROUTE)
            .get();
    }

    @ngAsync()
    public async getById(fondId: number): Promise<Fond> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${fondId}`)
            .get();
    }

    public async getCompatibleFonds(fondId: number): Promise<Fond[]> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${fondId}/compatible`)
            .get();
    }

    public async getFondFieldTypes(fondId: number): Promise<FondFieldType[]> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${fondId}/fields`)
            .get();
    }
}